import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PanelExpansion"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 4.5H4.5C3.67157 4.5 3 5.17157 3 6V10.5C3 11.3284 3.67157 12 4.5 12H9C9.82843 12 10.5 11.3284 10.5 10.5V6C10.5 5.17157 9.82843 4.5 9 4.5ZM4.5 10.5V6H9V10.5H4.5ZM19.5 4.5H15C14.1716 4.5 13.5 5.17157 13.5 6V18C13.5 18.8284 14.1716 19.5 15 19.5H19.5C20.3284 19.5 21 18.8284 21 18V6C21 5.17157 20.3284 4.5 19.5 4.5ZM15 18V6H19.5V18H15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PanelExpansion.vue"]]);
